<template>
  <div>
    <GenericField
      :value="value"
      :field="field"
      :items="computedItems"
      :classes="classes"
      clearable
      @input="updateValue"
    />
  </div>
</template>

<script>
import GenericField from '@/components/dynamic/form/templates/GenericField.vue';
import { requests } from '@/mixins/requests.js';

export default {
  components: { GenericField },
  props: {
    indice: {
      type: String,
      default: 'ES_TALENT_INDICE'
    },
    field: {
      type: Object,
      default: () => ({})
    },
    input: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: [String, Number, Boolean, Object, Array],
      default: null
    },
    classes: {
      type: String,
      default: null
    },
    viewOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      items: [],
      loading: false
    };
  },
  computed: {
    computedItems () {
      return this.items.reduce((acc, item) => {
        acc.push({
          value: item[this.field?.itemValue || 'uuid'],
          text: item[this.field?.itemText || 'wtitle']
        });
        return acc;
      }, []);
    }
  },
  watch: {
    field: {
      handler (newVal, oldVal) {
        if (!this.viewOnly && JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          this.getData();
        }
      },
      deep: true
    }
  },
  async mounted () {
    if (!this.viewOnly) {
      await this.getData();
    }

    if (this.field.name === 'position' && this.value) {
      this.$emit('init-position', this.items.find(item => item.uuid === this.value));
    }
  },
  methods: {
    async getData () {
      this.loading = true;

      const variables = {
        workspace: this.field.workspace,
        wtype: this.field.contentWtype,
        online: true,
        indice: this.indice,
        persistedFilters: this.field.additionalFilters,
        sort: this.field.name === 'position'
          ? [{ 'wtitle.raw': 'asc' }]
          : undefined
      };

      if (this.input.status) variables.status = this.input.status;

      const response = await requests.searchOpenSearchContent(variables);

      if (!response.success) {
        this.loading = false;

        // SHOW ERROR MESSAGE
        return;
      }

      this.loading = true;

      this.items = response.items;
    },
    updateValue (value) {
      this.$emit('input', value);

      if (['position', 'offerUuid'].includes(this.field.name)) {
        const foundedItem = this.items.find(item => item.uuid === value);
        this.$emit('item', foundedItem, this.field.name);
      }
    }
  }

};
</script>
